module.exports = __webpack_public_path__ + "img/minus.655b3a48.svg";